function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    border-radius: 100px;\n    box-sizing: border-box;\n    padding: ", " ", ";\n\n    &:not(:first-child) {\n      margin-top: ", ";\n    }\n\n    @media (max-width: ", ") {\n      width: 100%;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from "styled-components";
import { Registry } from "@cf-design-system/registry";
import { Notification as BaseNotification } from "@diana-ui/notification";
var Notification = styled(BaseNotification)((_ref) => {
  var {
    isError,
    theme
  } = _ref;
  return css(_templateObject(), isError ? css(_templateObject2(), theme.colors.alert.alert60) : css(_templateObject3(), theme.colors.green.green50), theme.spaceUnit.xs, theme.spaceUnit.md, theme.spaceUnit.xs, "".concat(theme.breakpoints.MOBILE_2, "px"));
});
Registry.register(Notification, "Notification");
export default Notification;